<template>
  <DashboardTemplate :navMenu="true" class="custom-activity">
    <div class="text-left pd-b-3 disabled-on-print">
      <h2 class="mg-less">สรุปรายชื่อผู้เรียนหลักสูตร</h2>
    </div>
    <div v-if="courseList.length > 0">
      <div class="pd-b-3 flex-display js-between change-display disabled-on-print">
        <div class="text-left flex-display ai-center change-display">
          <p class="mg-less">เลือกหลักสูตร</p>
          <el-dropdown class="mg-l-4" trigger="click">
            <span class="el-dropdown-link course-box">
              <span class="message-over clamp1">{{
                getCourseLabel(course)
              }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="course-box-menu">
              <el-dropdown-item v-for="item in courseList" :key="item._id">
                <div
                  :title="item.name"
                  @click="course = item._id"
                  class="width-100 dropdown-text-over"
                >
                  {{ item.name }}
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            @click="selectCourse"
            type="primary"
            class="light mg-l-4 btn-show"
            round
            >แสดงผล</el-button
          >
        </div>
        <div class="flex-display js-end search-download">
          <el-form @submit.prevent.native @keyup.enter.native="search">
            <el-input
              placeholder="ค้นหารายชื่อ"
              prefix-icon="el-icon-search"
              class="search-input"
              @blur="showInputSearch = false,!searchText && showSearch?search():null"
              @keyup.enter.native="search"
              @clear="searchText = '',search()"
              :class="{ show: showInputSearch }"
              ref="search"
              clearable
              v-model="searchText"
            ></el-input>

            <el-button
              v-if="!showInputSearch"
              @click="openSearchInput"
              icon="el-icon-search"
              round
              class="pd-x-2 primary border-color-primary"
              >ค้นหา</el-button
            >
          </el-form>
          <el-button @click="csvExport" type="primary" class="mg-l-4" round>ดาวน์โหลดข้อมูล</el-button>
        </div>
      </div>
      <div v-if="showSearch" class="text-left pd-b-3">
        <p class="mg-y-less">
          <span class="text-weight-600">ค้นหา</span> “{{ searchText }}”
        </p>
      </div>

      <el-tabs v-model="activeName" @tab-click="changeTab" class="secondary disabled-on-print">
        <el-tab-pane
          :label="`สรุปรายชื่อผู้สมัครหลักสูตร (${totalRegisters})`"
          name="1"
        >
          <div v-loading="loading">
            <ActivitySummaryStatusList
              :nameList="registers"
              dateLabel="วันที่และเวลาที่สมัคร"
              dateObj="createdAt"
              :showEmail="true"
              :pageSize="pageSize"
              :page="page"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="`สรุปรายชื่อผู้เข้าร่วมกิจกรรม (${totalStudying})`"
          name="2"
        >
          <div v-loading="loading">
            <ActivitySummaryStatusList
              :nameList="studying"
              dateLabel="วันที่และเวลาที่เข้าร่วม"
              dateObj="approveDate"
              :showEmail="true"
              :pageSize="pageSize"
              :page="page"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="`สรุปรายชื่อผู้เรียนผ่านกิจกรรม (${totalSuccess})`"
          name="3"
        >
          <div v-loading="loading">
            <div class="box-overflow">
              <ActivityNamelistScore
                :namelistScore="success"
                :showAction="true"
                :courseId="courseId"
                dateLabel="วันและเวลาที่จบ"
                dateObj="createdAt"
                :pageSize="pageSize"
                :page="page"
                @printCertificate="printCertificate"
              />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div  class="pd-y-3 disabled-on-print">
        <el-pagination
          v-if="totalData > 10"
          @current-change="changePage"
          background
          layout="prev, pager, next"
          :total="totalData"
          :page-size="pageSize"
          :current-page="page"
        ></el-pagination>
      </div>

      <div class="show-only">
        <div class="certificate-print-box">
          <CertificateCard
            :name="nameTh"
            :lastName="lastNameTh"
            :courseName="courseName"
            :endDate="endDate"
          />
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      <p class="color-gray pd-y-1">*** ไม่มีข้อมูลหลักสูตร ***</p>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ActivitySummaryStatusList from "@/components/activity/ActivitySummaryStatusList";
import ActivityNamelistScore from "@/components/activity/ActivityNamelistScore";
import { HTTP } from "@/service/axios.js";
import CertificateCard from "@/components/certificate/CertificateCard";
import {CancelToken } from "axios";

export default {
  components: {
    DashboardTemplate,
    ActivitySummaryStatusList,
    ActivityNamelistScore,
    CertificateCard
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
    courseList() {
      let courses = []
      if (this.user.role == 50) {
        this.$store.state.courseList.map((item)=>{
          let filter = item.subject.filter(filter => filter.instructor == this.user.userId)
          if (filter.length > 0) {
            courses.push(item)
          }
        })
      }else{
        courses = this.$store.state.courseList
      }

      return courses;
    }
  },
  data() {
    return {
      activeName: "1",
      course: "",
      searchText: "",
      showInputSearch: false,
      loading: true,
      registers: [],
      studying: [],
      success: [],
      totalRegisters: 0,
      totalStudying: 0,
      totalSuccess: 0,
      page: 1,
      pageSize: 10,
      totalData: 0,
      nameTh:'',
      lastNameTh:'',
      courseName:'',
      endDate:'',
      showSearch:false,
      sourceSuccess:'',
      sourceStudying:'',
      sourceRegisters:'',
      courseId:'',
      registersAll: [],
      studyingAll: [],
      successAll: [],
      sourceSuccessAll:'',
      sourceStudyingAll:'',
      sourceRegistersAll:'',
    };
  },
  mounted() {
    this.fetchCourseList();
    this.fetchStudentsRegisters()
    this.fetchStudentsStudying()
    this.fetchStudentsSuccess() 
    this.fetchStudentsRegistersAll()
    this.fetchStudentsStudyingAll()
    this.fetchStudentsSuccessAll()
     
  },
  methods: {
      csvExport() {
        let columnsTemplate =[
          'ลำดับ',
          'ชื่อ',
          'นามสกุล',
          'ชื่อบริษัท',
          'เบอร์โทรศัพท์',
          'อีเมล',
          `${this.activeName == 1?'วันที่และเวลาที่สมัคร':this.activeName == 2?'วันที่และเวลาที่เข้าร่วม':'วันและเวลาที่จบ'}`
        ]

        let title = []
        for (let index = 0; index < columnsTemplate.length; index++) {
          title.push(columnsTemplate[index])   
        }

        let dataList = this.activeName == 1?this.registersAll:this.activeName == 2?this.studyingAll:this.successAll
        let data = []
        for (let index = 0; index < dataList.length; index++) {
          let date=this.activeName == 1?this.$options.filters.dateTimeTh(dataList[index].createdAt)
          :this.activeName == 2?this.$options.filters.dateTimeTh(dataList[index].approveDate)
          :this.$options.filters.dateTimeTh(dataList[index].successDate)

          let obj ={
            index:index+1,
            nameTH:dataList[index].nameTH,
            surnameTH:dataList[index].surnameTH,
            companyName:dataList[index].companyName,
            mobilephone: dataList[index].mobilephone,
            email:dataList[index].email,
            createdAt:date
          }
          data.push(obj)   
        }
        
        let csvContent = "";
        csvContent += [
            title.join(","),
            ...data.map(item => Object.values(item).join(","))
        ]
            .join("\n")
            .replace(/(^\[)|(\]$)/gm, "");

          
        var link = window.document.createElement("a");
        link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent));
        let nameFile = this.activeName == 1?'รายชื่อผู้สมัครหลักสูตร':this.activeName == 2?'รายชื่อผู้เข้าร่วมกิจกรรม':'รายชื่อผู้เรียนผ่านกิจกรรม'
        let dataFile = nameFile+"_"+new Date().getDate()+'-'+(new Date().getMonth() + 1)+'-'+new Date().getFullYear()
        link.setAttribute("download", dataFile+'.csv');
        link.click();
    },
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
      this.course = this.courseList.length > 0 ? this.courseList[0]._id : "";
      this.courseId = this.course
    },
    fetchStudentsRegisters() {
      let obj = {
        courseId: this.courseId,
        search: this.searchText ? this.searchText : "all",
        page:(this.page - 1) * this.pageSize,
        limit:this.pageSize,
        type:1
      };

      if (this.sourceRegisters) {
          this.sourceRegisters.cancel()
      }

      this.sourceRegisters = CancelToken.source()
      const cancelToken = this.sourceRegisters.token

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/students`, obj,{cancelToken})
        .then((res) => {
          
          if (res.data.success) {
            this.registers = res.data.obj.users;
            this.totalRegisters = res.data.obj.total;
          } else {
            this.registers = [];
            this.totalRegisters = 0;
          }
        })
        .catch((e) => {
          console.log("fetchStudentsRegisters error", e);
        })
    },
    fetchStudentsStudying() {
      let obj = {
        courseId: this.courseId,
        search: this.searchText ? this.searchText : "all",
        page:(this.page - 1) * this.pageSize,
        limit:this.pageSize,
        type:2
      };

      if (this.sourceStudying) {
          this.sourceStudying.cancel()
      }

      this.sourceStudying = CancelToken.source()
      const cancelToken = this.sourceStudying.token

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/students`, obj,{cancelToken})
        .then((res) => {
  
          if (res.data.success) {
            this.studying = res.data.obj.users;
            this.totalStudying = res.data.obj.total;

          } else {
            this.studying = [];
            this.totalStudying = 0;
          }
        })
        .catch((e) => {
          console.log("fetchStudentsStudying error", e);
        })
    },
    fetchStudentsSuccess() {
      let obj = {
        courseId: this.courseId,
        search: this.searchText ? this.searchText : "all",
        page:(this.page - 1) * this.pageSize,
        limit:this.pageSize,
        type:3
      };

      if (this.sourceSuccess) {
          this.sourceSuccess.cancel()
      }

      this.sourceSuccess = CancelToken.source()
      const cancelToken = this.sourceSuccess.token

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/students`, obj,{cancelToken})
        .then((res) => {
  
          if (res.data.success) {
            this.success = res.data.obj.users;
            this.totalSuccess = res.data.obj.total;
          } else {
            this.success = [];
            this.totalSuccess = 0;
          }
        })
        .catch((e) => {
          console.log("fetchStudentsSuccess error", e);
        })
        .finally(() => {
          this.loading = false;
          this.setTotalPage()
        });
    },
    fetchStudentsRegistersAll() {
      let obj = {
        courseId: this.courseId,
        search: this.searchText ? this.searchText : "all",
        page:0,
        limit:0,
        type:1
      };

      if (this.sourceRegistersAll) {
          this.sourceRegistersAll.cancel()
      }

      this.sourceRegistersAll = CancelToken.source()
      const cancelToken = this.sourceRegistersAll.token

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/students`, obj,{cancelToken})
        .then((res) => {
          
          if (res.data.success) {
            this.registersAll = res.data.obj.users;
          } else {
            this.All = [];
          }
        })
        .catch((e) => {
          console.log("fetchStudentsRegistersAll error", e);
        })
    },
    fetchStudentsStudyingAll() {
      let obj = {
        courseId: this.courseId,
        search: this.searchText ? this.searchText : "all",
        page:0,
        limit:0,
        type:2
      };

      if (this.sourceStudyingAll) {
          this.sourceStudyingAll.cancel()
      }

      this.sourceStudyingAll = CancelToken.source()
      const cancelToken = this.sourceStudyingAll.token

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/students`, obj,{cancelToken})
        .then((res) => {
  
          if (res.data.success) {
            this.studyingAll = res.data.obj.users;
          } else {
            this.studyingAll = [];
          }
        })
        .catch((e) => {
          console.log("fetchStudentsStudyingAll error", e);
        })
    },
    fetchStudentsSuccessAll() {
      let obj = {
        courseId: this.courseId,
        search: this.searchText ? this.searchText : "all",
        page:0,
        limit:0,
        type:3
      };

      if (this.sourceSuccessAll) {
          this.sourceSuccessAll.cancel()
      }

      this.sourceSuccessAll = CancelToken.source()
      const cancelToken = this.sourceSuccessAll.token

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/students`, obj,{cancelToken})
        .then((res) => {
  
          if (res.data.success) {
            this.successAll = res.data.obj.users;
          } else {
            this.successAll = [];
          }
        })
        .catch((e) => {
          console.log("fetchStudentsSuccessAll error", e);
        })
    },
    selectCourse() {
      this.loading = true;
      this.courseId = this.course
      this.fetchStudentsRegisters()
      this.fetchStudentsStudying()
      this.fetchStudentsSuccess()
      this.fetchStudentsRegistersAll()
      this.fetchStudentsStudyingAll()
      this.fetchStudentsSuccessAll()
    },
    getCourseLabel(course) {
      let filter = this.courseList.filter((filter) => filter._id == course);
      return filter.length > 0 ? filter[0].name : "";
    },
    openSearchInput() {
      this.showInputSearch = true;
      if (!this.showSearch) {
        this.searchText = "";
      }

      setTimeout(() => {
        this.$refs.search.focus();
      }, 500);
    },
    search() {
      this.loading = true;
      this.page = 1
      this.fetchStudentsRegisters()
      this.fetchStudentsStudying()
      this.fetchStudentsSuccess() 
      this.fetchStudentsRegistersAll()
      this.fetchStudentsStudyingAll()
      this.fetchStudentsSuccessAll()
      if (this.searchText != "") {
        this.showSearch = true;
      } else {
        this.showSearch = false;
      }
    },
    changePage(page) {
      this.loading = true;
      this.page = page;
      this.fetchStudentsRegisters()
      this.fetchStudentsStudying()
      this.fetchStudentsSuccess()
    },
    changeTab() {
      this.loading = true;
      this.page = 1;
      this.setTotalPage()
      this.fetchStudentsRegisters()
      this.fetchStudentsStudying()
      this.fetchStudentsSuccess()
    },
    setTotalPage(){
      if (this.activeName == "1") {
        this.totalData =  this.totalRegisters;
      } else if (this.activeName == "2") {
        this.totalData = this.totalStudying;
      } else {
        this.totalData = this.totalSuccess;
      }
    },
    printCertificate(nameTH,surnameTH,successDate) {
      this.nameTh = nameTH
      this.lastNameTh = surnameTH
      this.courseName = this.getCourseLabel(this.course);
      this.endDate = successDate;

      setTimeout(() => {
        window.print();
      }, 500);
    },
  },
};
</script>